import { useRef, useState } from "react";

const useShare = (url: string) => {
  const [isCopySuccess, setIsCopySuccess] = useState(false);
  const timeoutRef = useRef<number>(undefined);

  const copyToClipboard = () => {
    const shareData = { url };

    // use share api if available, otherwise copy to clipboard
    if (navigator.canShare && navigator.canShare(shareData)) {
      navigator.share(shareData);
    } else if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url);
      setIsCopySuccess(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        setIsCopySuccess(false);
      }, 2000);
    }
  };

  const handleShare = () => {
    copyToClipboard();
  };

  return {
    handleShare,
    isCopySuccess,
  };
};

export default useShare;
